import axios from "axios";
import { createAuthenticatedAxiosInstance } from "../auth/auth.slice";

const baseUrl = import.meta.env.VITE_API_URL;

export const usersService = {
    getAllUsers: async () => {
        const axiosInstance = createAuthenticatedAxiosInstance();
        const response = await axiosInstance.get(`${baseUrl}users`);
        return response.data;
    },

    getUserById: async (id) => {
        const axiosInstance = createAuthenticatedAxiosInstance();
        const response = await axiosInstance.get(`${baseUrl}users/${id}`);
        return response.data;
    },

    createUser: async (userData) => {
        const axiosInstance = createAuthenticatedAxiosInstance();
        const response = await axiosInstance.post(`${baseUrl}users`, userData);
        return response.data;
    },

    updateUser: async (id, userData) => {
        const axiosInstance = createAuthenticatedAxiosInstance();
        const response = await axiosInstance.put(`${baseUrl}users/${id}`, userData);
        return response.data;
    },

    deleteUser: async (id) => {
        const axiosInstance = createAuthenticatedAxiosInstance();
        const response = await axiosInstance.delete(`${baseUrl}users/${id}`);
        return response.data;
    },
};
